import React from "react";
import "../../pages.css";
import img from "../../../assets/newImages/cartao-ouro.png";
import linha from "../../../assets/linha.png";
import TableGold from "../../../components/gold/tableGold";
import { PoliticaEntrega } from "../../../components/text/politcaEntrega";
import { texts } from "../../../utils/texts";
import { RedirectWhatsappMain } from "../../../components/whatsapp/whatsapp";

export default function BarraLaminas() {
  const ouro = texts.ouro;
  const navigate = () => {
    RedirectWhatsappMain(ouro.whatsAppMessage.default);
  };
  return (
    <article className="art-s mb-5 p-text">
      <section className="row m-0 sectionInit">
        <div className="c-init">
          <div className="c-init__text col-6  d-flex flex-column sect mt-5">
            <p className="fw-bolder text-decoration-underline">BARRA DE OURO</p>
            <p>
              A barra de ouro é um dos ativos mais valorizados e seguros do
              mercado financeiro. Na Ourominas, você pode comprar ouro físico
              com pureza 999, certificado de origem, nota fiscal eletrônica e
              garantia de recompra. Tudo com segurança, transparência e mais de
              40 anos de tradição.
            </p>
            <p>
              Na Ourominas, você encontra as melhores condições para comprar e
              vender ouro, seja em barras de 1g até 1kg, compramos seu ouro por
              meio de joias, moedas ou antigas barras.{" "}
            </p>
            <p>
              Trabalhamos com ouro extraído de áreas de lavra autorizadas pela
              Agência Nacional de Mineração (ANM), com certificação da AMAGOLD
              (Americas Gold Manufactures Association) – que assegura o teor,
              qualidade e conformidade com critérios internacionais. Nosso
              material é adquirido no mercado Balcão e no mercado primário, com
              origem rastreada e regularizada, ideal para quem procura investir
              com tranquilidade e credibilidade.{" "}
            </p>

            <p>Características do nosso ouro:</p>
            <p>
              <ul>
                <li>Teor de pureza: 999 (24k)</li>
                <li>Lacre individual com selo holográfico de segurança</li>
                <li>Nota Fiscal Eletrônica (NF-e)</li>
                <li>Certificado de Origem do Metal</li>
                <li>Garantia de recompra imediata</li>
              </ul>
            </p>
            <div className="div-line">
              <img src={linha} alt="linha de separação"></img>
            </div>
          </div>
          <div className="col-6 c-init__image">
            <img src={img} className="image" alt="grupo-om"></img>
          </div>
        </div>
        <p className="mt-5">
          Seja você um investidor especialista ou apenas começando, a Ourominas
          (OM) oferece acesso fácil a um mercado global, não importa se está
          comprando um grama ou uma tonelada, a empresa sempre oferece as
          melhores ofertas disponíveis no mercado de ouro e conta com uma equipe
          formada por profissionais graduados e mestres na área financeira para
          auxiliar o cliente da melhor maneira possível.
        </p>
        <p>
          O material vendido pela OM é adquirido no mercado Balcão e no mercado
          primário, extraído de área de produção mineral localizada no Brasil,
          oriundo de Permissões de Lavras Garimpeiras (PLG) autorizadas e
          conferidas pela Agência Nacional de Mineração (ANM) e pela Americas
          Gold Manufactures Association (AMAGOLD), certificação de qualidade que
          é dada às empresas que passam por uma rigorosa análise, averiguando
          inclusive sua forma de produção para adequação nos critérios mais
          rígidos de qualidade.
        </p>

        <p>
          Todo ouro comercializado na OM possui teor de pureza 999, são lacrados
          individualmente com selos holográficos tridimensionais que garantem a
          segurança e a qualidade do produto, acompanha Nota Fiscal Eletrônica
          (NF-e), Garantia de Recompra e Certificado de Origem do Metal.
        </p>

        <p className="mt-4">
          <b>Nossas Barras</b>
        </p>
        <TableGold />

        <section className="mt-4 sect">
          <p className=" mt-5 my-3  fw-bolder">PERGUNTAS FREQUENTES</p>
          <details className="mb-2 pb-2 border-bottom">
            <summary>POR QUE INVESTIR EM OURO?</summary>
            <p className="mt-4">
              Ao longo da história, o ouro sempre desempenhou um papel
              fundamental no poder e na economia global. Antes mesmo da criação
              das moedas como meio de troca, civilizações antigas já atribuíam
              um valor especial ao metal dourado, associando-o ao Sol, enquanto
              a prata era vinculada à Lua. Essa ligação mística reforçou a
              crença no poder e na raridade desses metais.
            </p>
            <p>
              De <strong>1875 até meados do século XX</strong>, o ouro foi a
              base do sistema monetário global, servindo como referência
              econômica internacional no chamado <strong>“padrão-ouro”</strong>.
              Nesse modelo, os países eram obrigados a manter parte
              significativa de suas reservas internacionais em ouro,
              influenciando diretamente suas políticas de comércio exterior.
            </p>
            <p>
              Mesmo após a consolidação do dólar como moeda de referência global
              no final do século XX, o ouro manteve seu prestígio. Em{" "}
              <strong>2018</strong>, por exemplo, os{" "}
              <strong>
                Bancos Centrais ao redor do mundo compraram mais ouro do que em
                qualquer outro ano desde 1971
              </strong>
              , reforçando sua relevância como ativo seguro e reserva de valor.
            </p>
            <p>
              Investir em ouro significa apostar em um ativo sólido, atemporal e
              resistente a crises econômicas, sendo uma proteção contra a
              inflação e instabilidades financeiras.
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>
          <details className="mb-2 pb-2 border-bottom">
            <summary>POR QUE INVESTIR EM OURO COM A OUROMINAS?</summary>
            <p className="my-4">
              <p>
                Investir em ouro físico com a Ourominas (OM) é a escolha ideal
                para quem busca segurança patrimonial, transparência e condições
                diferenciadas no mercado de metais preciosos. Com mais de 40
                anos de tradição, a OM é referência nacional na compra e venda
                de barras de ouro puro 999, com certificação de origem, nota
                fiscal eletrônica e garantia de recompra.
              </p>
              <p>Cotações Competitivas no Mercado de Ouro </p>
              <p>
                A Ourominas negocia ouro físico com base nas cotações do mercado
                nacional e internacional, garantindo que o investidor compre
                barra de ouro pelo menor preço possível. E o melhor:
              </p>
              <p>Sem taxa de confecção, </p>
              <p>Sem corretagem, </p>
              <p>Sem taxas administrativas. </p>
              <p>
                Tanto para pequenos investidores quanto para compras maiores, a
                OM oferece preços justos e acessíveis para quem deseja comprar
                ouro como investimento seguro.{" "}
              </p>
              <hr></hr>
              <p>2. Preço Único: Transparência nas Cotações</p>
              <p>
                Diferente de outras empresas do setor, a Ourominas aplica o
                mesmo preço do ouro para todos os clientes, independentemente da
                quantidade comprada. Isso garante transparência e igualdade,
                seja para quem compra 1g ou 1kg de ouro.
              </p>
              <hr></hr>
              <p>3. Zero Taxas Ocultas </p>
              <p>
                Investir em ouro pela Ourominas significa evitar taxas comuns em
                fundos de investimento, como:
              </p>
              <p>Taxa de administração;</p>
              <p>Taxa de performance; </p>
              <p>Taxa de entrada ou saída. </p>
              <p>
                Aqui, você compra e vende ouro físico sem custos adicionais, com
                liberdade para investir de forma diária, semanal ou mensal,
                conforme sua estratégia.{" "}
              </p>
              <hr></hr>
              <p>4. Ouro com Liquidez Imediata e Facilidade de Acesso </p>
              <p>
                Ao contrário da bolsa de valores, na Ourominas você compra ouro
                físico com entrega rápida e segura. Isso garante ao investidor
                maior liquidez, já que a posse é imediata e a recompra pode ser
                feita de forma simples.
              </p>
              <p>
                Você recebe a barra de ouro em mãos, com lacre de segurança,
                selo holográfico e certificado. Tudo pronto para guardar,
                revender ou declarar como patrimônio.{" "}
              </p>
              <hr></hr>
              <p>5. Tradição, Segurança e Credibilidade no Mercado</p>
              <p>
                Com mais de 40 anos de experiência no mercado de ouro, a
                Ourominas é:
              </p>
              <p>Autorizada pelo Banco Central do Brasil;</p>
              <p>Autorizada pelo Banco Central do Brasil; </p>
              <p>Credenciada pela Comissão de Valores Mobiliários (CVM); </p>
              <p>
                Reconhecida por sua reputação sólida e equipe especializada em
                investimentos em ouro físico.{" "}
              </p>
              <p>
                A empresa atua com responsabilidade, seguindo todas as normas
                legais e regulatórias, para garantir a proteção e o crescimento
                do seu patrimônio.{" "}
              </p>
              <hr></hr>

              <p>Invista com Confiança: Barra de Ouro é na Ourominas </p>
              <p>
                Se você está buscando onde comprar ouro com segurança, a
                Ourominas é a melhor escolha. Com atendimento especializado,
                entrega garantida e estrutura nacional, você pode começar seu
                investimento em barras de ouro puro 999 com total tranquilidade.{" "}
              </p>
              <button className="button-chart" onClick={navigate}>
                {ouro.buttons.investir}
              </button>
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary>COMPRAR OURO COM SEGURANÇA E PRATICIDADE</summary>
            <p className="my-4">
              <p>
                Comprar Ouro nunca foi tão simples, com a Ourominas, você tem
                acesso facilitado ao mercado global de ouro, independentemente
                do valor que deseja investir.
              </p>
              <ul>
                <li>
                  Compre de forma presencial ou com entrega segura em todo o
                  Brasil{" "}
                </li>
                <li>
                  Atendimento consultivo com especialistas em ouro e
                  investimentos{" "}
                </li>
                <li>
                  Atendimento via Central de Vendas especializada, loja física,
                  WhatsApp, telefone ou e-commerce é a maneira mais segura e
                  econômica de garantir tranquilidade ao chegar no destino.{" "}
                </li>
              </ul>
              <p>Na Ourominas, o processo de compra é simples: </p>
              <ul>
                <li>
                  Simule ou solicite a cotação do ouro na gramatura em barras
                  que deseja.{" "}
                </li>
                <li>Cadastre-se com seus dados e documentos. </li>
                <li>Realize o pagamento por PIX ou TED. </li>
                <li>Receba suas barras de ouro, por delivery ou retirada. </li>
              </ul>
              <p>
                <b>Importante: </b> Conforme exigência do Banco Central, o valor
                creditado na conta da OM deve sair da conta do titular do pedido
                / aquisição. A operação deverá ser liquidada no prazo combinado,
                pois do contrário será cancelada.{" "}
              </p>
              <button className="button-chart" onClick={navigate}>
                {ouro.buttons.investir}
              </button>
            </p>
          </details>
          <details className="mb-2 pb-2 border-bottom">
            <summary>INVESTIR EM OURO VALE A PENA?</summary>
            <p className="my-4">
              <ol>
                <li>
                  É a única moeda que não está sob o controle de qualquer
                  governo e, portanto, não sofre ingerência governamental.
                </li>
                <li>
                  Os excessos de liquidez e de dinheiro na economia cria
                  inflação ou inflação potencial, desvalorizando ou criando
                  potencial para a desvalorização das moedas que circulam em
                  excesso.
                </li>
                <li>
                  O ouro é um valor seguro sempre, enquanto ações de empresas e
                  outras modalidades de investimentos sofrem bastante em
                  cenários de crise.
                </li>
                <li>
                  A descoberta do ouro como investimento em economias emergentes
                  vem aumentando.
                </li>
                <li>
                  O ouro é um investimento de altíssima liquidez. Existem muito
                  poucos outros investimentos que podem reverter-se em dinheiro
                  de maneira tão rápida como o ouro: sem penalizações, sem
                  espera de tempo, sem condições adicionais.
                </li>
                <li>
                  O ouro adquirido de instituições financeiras no Brasil é
                  definido na Constituição como ativo financeiro, estando
                  sujeito à tributação incidente sobre a renda variável.
                </li>
              </ol>
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>
          <details className="mb-2 pb-2 border-bottom">
            <summary>OQUE É O OURO 999?</summary>
            <p>
              Ouro 999 é o ouro com pureza de 99,9%, também conhecido como ouro
              24 quilates. É o padrão utilizado internacionalmente para
              investimentos em barra de ouro físico, sendo aceito em todos os
              mercados globais.
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>
          <details className="mb-2 pb-2 border-bottom">
            <summary>COMO É FEITA A ENTREGA DA BARRA DE OURO?</summary>
            <p>
              A Ourominas oferece entrega segura e discreta via transportadora
              especializada ou retirada em loja. As barras são lacradas
              individualmente com selo holográfico de segurança, acompanhadas de
              nota fiscal eletrônica (NF-e) e certificado de origem do metal.
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary>PRECISO DECLARAR O OURO NO IMPOSTO DE RENDA?</summary>
            <p>
              Sim. A posse de ouro como ativo financeiro deve ser informada na
              sua declaração anual de imposto de renda. A Ourominas fornece nota
              fiscal e certificado, o que facilita a comprovação da origem e
              valor do investimento.
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary>
              É POSSÍVEL VENDER O OURO DE VOLTA PARA A OUROMINAS?
            </summary>
            <p>
              Sim. A Ourominas possui garantia de recompra. Você pode vender seu
              ouro físico conosco de forma segura, com cotação transparente e
              pagamento ágil. Basta apresentar a documentação e a barra com
              lacre original.
            </p>
            <p>
              Na OM é possível vender suas barras de Ouro, barras de outras
              instituições, joias ou moedas de ouro em quaisquer quilates.{" "}
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary>QUAL É O VALOR MÍNIMO PARA COMPRAR OURO?</summary>
            <p>
              Na Ourominas, você pode começar seu investimento com barras a
              partir de 1g. Isso torna o investimento em ouro acessível para
              iniciantes e vantajoso para investidores experientes que desejam
              diversificar seu portfólio.{" "}
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary>
              QUAL A DIFERENÇA ENTRE OURO FÍSICO E OURO FINANCEIRO?
            </summary>
            <p>
              Ouro físico é o metal em sua forma tangível, como barras ou joias,
              de posse direta do investidor. Já o ouro financeiro é representado
              por contratos ou fundos, sujeitos a risco de contraparte e
              variação de mercado. O ouro físico da Ourominas garante
              propriedade direta e segurança real.{" "}
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary>COMO SABER SE A BARRA DE OURO É VERDADEIRA?</summary>
            <p>As barras de ouro da Ourominas são acompanhadas de: </p>
            <ul>
              <li>Lacre holográfico tridimensional, </li>
              <li>Certificado de origem, </li>
              <li>Nota Fiscal Eletrônica (NF-e), </li>
              <li>Número de série exclusivo. </li>
            </ul>
            <p>
              Tudo para garantir a autenticidade e segurança do seu
              investimento.{" "}
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>

          <details className="mb-2 pb-2 border-bottom" id="politicaEntrega">
            <summary>POLÍTICA DE ENTREGA - BARRAS DE OURO</summary>
            <p>
              <b>Correios (SEDEX com seguro) </b>
            </p>
            <ul>
              <li>Entrega em todo o Brasil. </li>
              <li>Valor máximo por envio: R$ 35.571,17 – por envio. </li>
              <li>
                Todas as remessas são asseguradas e acompanhadas do contrato de
                câmbio.{" "}
              </li>
              <li>
                Prazo para postagem: 3 a 7 dias úteis após confirmação de
                pagamento.{" "}
              </li>
            </ul>
            <p>
              Áreas com restrição de entrega receberão o aviso para retirada em
              agência dos Correios.{" "}
            </p>
            <p>
              Prazo de guarda: 7 dias corridos - após será devolvida ao
              remetente e gerada uma nova cobrança.{" "}
            </p>

            <p>
              <b>Portador de Valores (regiões selecionadas) </b>
            </p>
            <ul>
              <li>Disponível para São Paulo (capital) e Grande SP*. </li>
              <li>Valor mínimo para envio: R$ 2.000,00. </li>
              <li>Entregas de segunda a sexta, das 9h às 18h. </li>
              <li>
                Entrega exclusiva ao titular ou mediante autorização prévia por
                escrito.{" "}
              </li>
              <li>Regiões fora da cobertura podem ter custo adicional. </li>
            </ul>
            <p>
              *Regiões atendidas: Osasco, Diadema (centro), São Bernardo do
              Campo, Santo André, Guarulhos, Barueri, Santana de Parnaíba, São
              Caetano do Sul e Alphaville.{" "}
            </p>
            <p>
              **Regiões não atendidas via portador de valores: Caieiras,
              Itapevi, Carapicuíba, Itapecerica da Serra, Taboão da Serra,
              Franco da Rocha, Francisco Morato, Itaquaquecetuba, Mogi das
              Cruzes, Mauá, Ribeirão Pires e Suzano.{" "}
            </p>
            <p>
              **Entregas fora da área serão convertidas em envio via Correios
              com custos de frete repassados.{" "}
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary>POR QUE TANTA GENTE INVESTE EM OURO?</summary>
            <p className="mt-4">
              O ouro costuma reluzir ainda mais aos olhos dos investidores em
              momentos de crise e pressão inflacionária.
            </p>
            <p>
              Consolidado no imaginário popular como símbolo de luxo e
              ostentação de reis, o metal dourado resistiu a guerras e
              catástrofes naturais porque é menos suscetível à especulação dos
              bancos e do mercado.
            </p>
            <p>
              Pode ser vendido em qualquer momento e em qualquer lugar do
              planeta, por isso é chamado de “dinheiro real”. Na prática, o ouro
              preserva patrimônio e compensa o risco de outras aplicações
              financeiras tradicionais.
            </p>
            <p>
              A lógica do ouro é a seguinte: quanto mais a bolsa cai e o dólar
              se desvaloriza, mais a cotação do ouro aumenta, por pura lei de
              oferta e demanda.
            </p>
            <p>
              O que acontece nessa situação é que simplesmente os investidores
              retiram seu capital da bolsa de valores e do dólar durante as
              crises para alocar na segurança do metal dourado.
            </p>
            <p>
              Assim, se você perceber tendência de queda do dólar e perda de
              fôlego nos gráficos da bolsa (sinais de crise econômica), é
              praticamente certo que virá uma valorização do ouro em seguida.
            </p>
            <p>
              É preciso lembrar que o ouro, diferentemente de um papel-moeda, é
              de prospecção limitada. E, mais do que isso, um mineral já
              bastante explorado — há séculos — no Brasil e em outras nações
              colonizadas.
            </p>
            <p className="mb-4">
              Dessa forma, com a escassez das jazidas mundiais, o metal amarelo
              ainda circulante no mercado tende a se valorizar ainda mais.
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>
          <details className="mb-2 pb-2 border-bottom">
            <summary>COMO COMPRAR OURO?</summary>
            <strong>Cadastre-se na OM </strong>
            <p>
              • Escolha entre o <strong>Cadastro Simplificado</strong> (para
              operações de pequeno valor) ou o{" "}
              <strong>Cadastro Completo</strong> (para valores maiores e
              operações recorrentes).
            </p>
            <strong>Entre em Contato </strong>
            <p className="mb-4">
              • Realize suas compras por meio dos canais oficiais de atendimento
              da OM presencial ou online.
            </p>
            <strong>Confirme a Operação </strong>
            <p className="mb-4">
              • Após a negociação, a operação deve ser liquidada dentro do prazo
              combinado. Caso contrário, será cancelada automaticamente.
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>
          <details className="mb-2 pb-2 border-bottom">
            <summary>O OURO POSSUI GARANTIA?</summary>
            <p className="my-4">
              Todo ouro comercializado na OM possui pureza de 999, acompanha
              nota fiscal de negociação e tem recompra garantida. Para sua
              segurança, mantenha sempre as notas fiscais junto ao metal
              adquirido.
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>
          <details className="mb-2 pb-2 border-bottom">
            <summary>CADASTRO E REQUISITOS OBRIGATÓRIOS</summary>
            <p className="mt-4">
              A Ourominas segue todas as exigências da legislação brasileira
              para prevenção à lavagem de dinheiro (PLD/FT) é obrigada a seguir
              os procedimentos cadastrais. A empresa protege as informações de
              seus clientes e não repassa a terceiros, salvo sob determinação do
              Banco Central do Brasil.
            </p>
            <p>
              {" "}
              <b>Cadastro Simplificado: </b>
            </p>
            <ul>
              <li>
                Informar e preencher corretamente os dados cadastrais (e-mail,
                endereço e telefone atualizado.{" "}
              </li>
              <li>RG e CPF ou CNH e comprovante de endereço. </li>
            </ul>

            <p>
              <b>Cadastro Completo: </b>
            </p>
            <ul>
              <li>Documentos e dados acima </li>
              <li>Declaração e recibo do Imposto de renda PF </li>
              <li>E / ou origem dos recursos. </li>
            </ul>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary>ATENDIMENTO ESPECIALIZADO</summary>
            <p>
              Nosso atendimento é personalizado, com consultores preparados para
              orientar sua compra ou venda de ouro físico com total
              transparência e segurança.
            </p>
            <p>
              Produtos e serviços que o cliente encontra através deste canal:{" "}
            </p>
            <ul>
              <li>Barras de Ouro físico </li>
              <li>Cartão Temático OuroFácil; </li>
              <li>Compra de ouro em barras, moedas de ouro ou joias; </li>
              <li>Lâminas de ouro; </li>
              <li>Pirâmide de ouro. </li>
            </ul>
            <p>
              <strong>WhatsApp:</strong>{" "}
              <a href="https://wa.me/551123949845" target="_blank" rel="noreferrer">
                11 2394-9845 (somente mensagem)
              </a>
              <br />
              <strong>Telefone:</strong>{" "}
              <a href="tel:+551131163663">11 3116-3663</a>
              <br />
              <strong>E-mail:</strong>{" "}
              <a href="mailto:atendimento@ourominas.com">
                atendimento@ourominas.com
              </a>
            </p>

            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>
          <details className="mb-2 pb-2 border-bottom">
            <summary>HORÁRIO DE NEGOCIAÇÃO.</summary>
            <p className="my-4">
              Nosso horário de negociação: Segunda à Sexta, das 8:30 às 18:00h
              (Horário de Brasília). Temos horários diferenciados em alguns
              pontos de atendimento.
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary>TRIBUTAÇÃO DO OURO.</summary>
            <p className="mt-4">
              O investimento em Ouro Ativo Financeiro é classificado como
              aplicação em Renda Variável, regulamentado pela{" "}
              <strong>Lei nº 11.033, de 21 de dezembro de 2004</strong>, e pela{" "}
              <strong>
                Instrução Normativa RFB nº 1.022, de 5 de abril de 2010
              </strong>
              .
            </p>
            <p>
              <strong>Tributação sobre Ganhos de Capital:</strong>
            </p>
            <p>
              • Há <strong>isenção de Imposto de Renda</strong> sobre ganhos de
              capital em aplicações de renda variável, desde que o valor total
              das alienações mensais desses ativos não ultrapasse{" "}
              <strong>R$ 20.000,00</strong> em cada mercado (ações e Ouro Ativo
              Financeiro são considerados separadamente dentro do mesmo mês).{" "}
            </p>
            <p>
              • Caso haja isenção, os ganhos devem ser informados na declaração
              de Imposto de Renda no campo{" "}
              <strong>"Rendimentos Isentos e Não Tributáveis"</strong>.
            </p>

            <p>
              <strong>
                Tributação para Valores Superiores a R$ 20.000,00:
              </strong>
            </p>
            <p>
              • Se o total das alienações mensais de ativos de renda variável
              superar <strong>R$ 20.000,00</strong>, aplica-se uma alíquota de
              <strong> 15% sobre os ganhos de capital obtidos</strong> . O
              recolhimento deve ser feito até o último dia útil do mês seguinte
              via <strong>Carnê-Leão</strong>.
            </p>
            <p>
              • Para operações de
              <strong> Day-trade </strong>(compra e venda no mesmo dia), a
              alíquota é de <strong>20% sobre o ganho</strong> .
            </p>

            <p>
              <strong>ICMS:</strong>
            </p>
            <p>
              • <strong> Não há incidência de ICMS </strong>na comercialização
              de Ouro Ativo Financeiro.
            </p>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary>DECLARAÇÃO DE OURO NO IRPF.</summary>
            <p className="mt-4">
              O ouro deve ser declarado no{" "}
              <strong>Imposto de Renda Pessoa Física (IRPF)</strong>, mas a
              forma de declaração depende do tipo de ouro adquirido.
            </p>
            <ol>
              <li>
                <strong>Ouro como Ativo Financeiro:</strong> Se você investiu em{" "}
                <strong>Ouro Ativo Financeiro</strong>, que é negociado em
                bolsas de valores ou instituições financeiras, ele é considerado
                renda variável e deve ser declarado da seguinte forma:
              </li>
              <ul>
                <p style={{ marginLeft: "-30px", marginTop: "10px" }}>
                  • <strong>Na ficha "Bens e Direitos"</strong> → Código{" "}
                  <strong>04 – Aplicações e Investimentos</strong>
                </p>
                <li>
                  Informe o saldo em ouro que você possuía em 31/12 do ano-base.
                </li>
                <li> Utilize a cotação de aquisição, não a cotação atual.</li>
                <p style={{ marginLeft: "-30px", marginTop: "10px" }}>
                  • <strong>Ganhos de capital</strong> (lucro na venda acima de
                  R$ 20.000,00 no mês) devem ser tributados e informados na
                  ficha <strong>"Renda Variável"</strong>.
                </p>
              </ul>

              <li>
                <strong>Ouro Físico (Joias, Barras ou Moedas):</strong>Se você
                comprou ouro em barras, moedas ou joias para fins de patrimônio,
                ele deve ser declarado como <strong>bem pessoal</strong>, da
                seguinte maneira:
                <ul>
                  <p style={{ marginLeft: "-30px", marginTop: "10px" }}>
                    • <strong>Na ficha "Bens e Direitos"</strong> → Código{" "}
                    <strong>11 – Ouro, Joias e Objetos de Valor</strong>
                  </p>
                  <li>
                    Descreva a quantidade adquirida, tipo (barra, moeda, etc.) e
                    o local de custódia.
                  </li>
                  <li> Informe o valor pago na aquisição.</li>
                  <li>
                    O valor deve permanecer o mesmo até a venda (não há correção
                    pelo preço de mercado).
                  </li>
                </ul>
              </li>
            </ol>
            <button className="button-chart" onClick={navigate}>
              {ouro.buttons.investir}
            </button>
          </details>
        </section>
      </section>
    </article>
  );
}
